import { homeURL, loginURL } from "src/settings/config";
import { notify } from "src/services/Notification/Notification";

export const AuthorizationRequired = (message) => {
    notify(message, "error")
    localStorage.removeItem("access_token");
    setTimeout(() => {
        window.location.replace(`${loginURL}?redirect=${homeURL}`);
    }, 1000);
};